import { Color, Group, LineSegments, Mesh, MeshBasicMaterial, MeshLambertMaterial, MeshPhongMaterial, MeshStandardMaterial, Object3D, Texture } from 'three';

/** Workaround for threeJs instanceof checks not being reliable.
 * Type checks with threeJs should always rely on their ".isXXX" property */
export class IsThreeJsType {

  public static meshPhongMaterial(value: any): value is MeshPhongMaterial {
    return (value as MeshPhongMaterial)?.isMeshPhongMaterial == true;
  }

  public static meshBasicMaterial(value: any): value is MeshBasicMaterial {
    return (value as MeshBasicMaterial)?.isMeshBasicMaterial == true;
  }

  public static meshLambertMaterial(value: any): value is MeshLambertMaterial {
    return (value as MeshLambertMaterial)?.isMeshLambertMaterial == true;
  }

  public static color(value: any): value is Color {
    return (value as Color)?.isColor == true;
  }

  public static texture(value: any): value is Texture {
    return (value as Texture)?.isTexture == true;
  }

  public static mesh(value: any): value is Mesh {
    return (value as Mesh)?.isMesh == true;
  }

  public static lineSegments(value: any): value is LineSegments {
    return (value as LineSegments)?.isLineSegments == true;
  }

  public static group(value: any): value is Group {
    return (value as Group)?.isGroup == true;
  }

  public static object3D(value: any): value is Object3D {
    return (value as Object3D)?.isObject3D == true;
  }

  public static meshStandardMaterial(value: any): value is MeshStandardMaterial {
    return (value as MeshStandardMaterial)?.isMeshStandardMaterial == true;
  }
}
